import StepsForm from "@/components/Forms/StepsForm";

export default function SidebarCrear({ steps, onComplete, initialData, isLoading, onFieldChange }) {
  return (
    <div className={`w-full lg:w-2/5 xl:w-1/4 h-dvh bg-aw-bluedark-95 text-white py-4 border-r border-aw-bgbluedark`} >
      <StepsForm 
        steps={steps} 
        onComplete={onComplete} 
        initialData={initialData}
        isLoading={isLoading}
        onFieldChange={onFieldChange}
      />
    </div>
  );
}
